import { render, staticRenderFns } from "./HelpCenterDialog.vue?vue&type=template&id=1f46e091&scoped=true&"
import script from "./HelpCenterDialog.vue?vue&type=script&lang=js&"
export * from "./HelpCenterDialog.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterDialog.vue?vue&type=style&index=0&id=1f46e091&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f46e091",
  null
  
)

export default component.exports